import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Pagination, Row } from 'antd';
import { Delete_ObjectType_Api, GetAll_Paging_ObjectType_Api } from '../../API/objectTypeApi';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { ConfigProvider } from 'antd';
import faIR from 'antd/locale/fa_IR';
// ======================================================================
export const AllObjectTypeComponent = ({
    setLoading,
    showMessage,
    version,
    currentPage,
    setCurrentPage,
    isShowEdit = false,
    isShowDelete = false,
    isShowInsert = false,
    onAddClick,
    onEdit,
    onRowDeleted,
    onClickItem }) => {
    // ======================================================================
    const [objectTypes, setObjectTypes] = useState([]);
    const [pageCount, setPageCount] = useState(4);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, [currentPage, version]);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Paging_ObjectType_Api({ pageNumber: currentPage, });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setPageCount(data.messageData.pageCount * 10)
                setObjectTypes(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const deleteRow = async (id) => {
        try {
            setLoading(true);
            let data = await Delete_ObjectType_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                onRowDeleted();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (
        <>
            <Row className='sectionTitle'>
                {isShowInsert ?
                    (<>
                        <Col xs={14} sm={14} md={16} lg={18} xl={18}>
                            <h2 >
                                لیست انواع موجودیت
                            </h2>
                        </Col>
                        <Col xs={10} sm={10} md={8} lg={6} xl={6} style={{ textAlign: "left" }}>
                            <Button className='btn-primary'
                                onClick={() => onAddClick()} >
                                <PlusOutlined />
                                ایجاد رکورد جدید
                            </Button>
                        </Col>
                    </>) :
                    (
                        <Col span={24}>
                            <h2 >
                                لیست انواع موجودیت
                            </h2>
                        </Col>
                    )
                }

            </Row>
            <div className='container'>
                {objectTypes.map((objectType, key) =>
                    <>
                        <Row key={key} className="valueRow" >
                            <Col className="valueColumn textRight clickable" xs={12} sm={12} md={12} lg={15} xl={15} onClick={() => onClickItem(objectType.id)} >
                                {objectType.title}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={9} xl={9} style={{ textAlign: "left" }}>

                                {isShowEdit ? (
                                    <Button className='btn-success' style={{ marginLeft: "2px" }} onClick={() => onEdit(objectType.id)}>
                                        <EditOutlined />
                                        ویرایش</Button>
                                ) : (<></>)}

                                {isShowDelete ? (
                                    <Button
                                        className='btn-danger'
                                        onClick={() => {
                                            Modal.confirm({
                                                title: 'آیا از حذف ' + objectType.title + ' اطمینان دارید؟',
                                                onOk: () => { deleteRow(objectType.id) },
                                                footer: (_, { OkBtn, CancelBtn }) => (
                                                    <>
                                                        <CancelBtn />
                                                        <OkBtn />
                                                    </>
                                                ),
                                            });
                                        }}
                                    >
                                        <DeleteOutlined />
                                        حذف</Button>
                                ) : (<></>)}

                            </Col>
                        </Row>
                    </>
                )}
            </div>
             <ConfigProvider direction="rtl" locale={faIR}>
            <Pagination current={currentPage} 
                  showSizeChanger={false} 
                            showQuickJumper={false} 
            align="center" onChange={(page) => setCurrentPage(page)} total={pageCount} />
                </ConfigProvider>
        </>
    )
}